import actions from './manageClientDocument.actions'

export default {
  namespaced: true,
  actions
}
